import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { tournamentsRouteI18n } from '../i18n/tournaments-route-i18n';

export function tournamentsRoutePath(): string {
  return `${langRoutePath()}/${tournamentsRouteI18n()}`;
}
